import React, { useCallback, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import './SelectUserAndWorkers.css'
import TextInput from '../UIkit/TextInput'
import SearchIcon from '@mui/icons-material/Search'
import DropdownList from './DoropdownList'
import { toKanaString } from '../../functions/common'
import { resolveWorkerName } from '../../functions/worker/resolveWorkerName'
import { getWorkersRecords } from '../../functions/users'
import classModule from './SelectWorker.module.scss'

const useStyles = makeStyles((theme) => ({
  userSearch: {
    display: 'flex',
    alignItems: 'center',
  },
  searchButton: {
    marginTop: '20px',
    width: '24px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#757575',
  },
}))

const SelectEmail = (props) => {
  const classes = useStyles()
  const { setShowSelectEmail, email, setEmail } = props
  const [searchWords, setSearchWords] = useState('') //名称
  const [userList, setUserList] = useState([])
  const [prevUser, setPrevUser] = useState({
    email: email,
  })
  //未使用
  const [username, setUsername] = useState('')
  const [usernumber, setUsernumber] = useState('')
  const [userdepnumber, setUserdepnumber] = useState('')
  const [userdepname, setUserdepname] = useState('')

  //カナが入力されたとき
  const inputSearchWords = useCallback((event) => {
    const rawValue = event.target.value
    // let convStr = toKanaString(rawValue); // 変換処理
    // if(convStr.length > rawValue.length){
    //   convStr = convStr.substring(0, rawValue.length);
    // }
    setSearchWords(rawValue)
  }, [])
  //検索ボタンが押されたとき
  const handlesearchButtonClick = async () => {
    //検索処理
    if (searchWords.length === 0) {
      setUserList([])
      return
    }
    try {
      const convStr = toKanaString(searchWords)
      const records = await getWorkersRecords(convStr)
      //console.log(records);
      const names = []
      records.forEach(function (record) {
        names.push([
          record.B178_id.value,
          resolveWorkerName(record),
          record.B178_syozoku_cd.value,
          record.B178_syozoku_name.value,
          record.B178_gmail.value,
          'customer',
          '',
        ])
      })
      names.sort(function (a, b) {
        if (Number(a[0]) < Number(b[0])) return -1
        if (Number(a[0]) > Number(b[0])) return 1
        return 0
      })

      setUserList(names)
    } catch (error) {
      console.log('Error during search: ', error)
    }
  }
  //決定ボタンが押されたとき
  const handleDecideButtonClick = () => {
    setShowSelectEmail(false)
  }
  //キャンセルボタンが押されたとき
  const handleCancelButtonClick = () => {
    setEmail(prevUser.email)
    setShowSelectEmail(false)
  }
  // ];
  return (
    <aside className={classModule.modalContainer}>
      <div className={classModule.modal}>
        <h2 className="u-text__headline u-text-center">社員検索</h2>
        <div className={classes.userSearch}>
          <TextInput
            fullWidth={true}
            label={'氏名かな（前方一致）'}
            multiline={false}
            required={true}
            minRows={1}
            type={'text'}
            onChange={inputSearchWords}
            value={searchWords}
          />
          <button
            className={classes.searchButton}
            onClick={handlesearchButtonClick}
          >
            <SearchIcon />
          </button>
        </div>
        <DropdownList
          userList={userList}
          setUsername={setUsername}
          setUsernumber={setUsernumber}
          setUserdepnumber={setUserdepnumber}
          setUserdepname={setUserdepname}
          setEmail={setEmail}
        />
        <div className={classModule.buttons}>
          <button
            className={classModule.okButton}
            onClick={handleDecideButtonClick}
          >
            決定
          </button>
          <button
            className={classModule.ngButton}
            onClick={handleCancelButtonClick}
          >
            キャンセル
          </button>
        </div>
      </div>
    </aside>
  )
}

export default SelectEmail
